import Handsontable from "handsontable";
import Core from "handsontable/core";
import { CellProperties } from "handsontable/settings";
import { MatrixParameterValue } from "../interfaces/MatrixInputCell";
import { applyMatrixInputCellFeedback } from "./MatrixInputCellFeedback";

const customTextRenderer = (
  instance: Core,
  td: HTMLTableCellElement,
  rowIndex: number,
  colIndex: number,
  prop: string | number,
  cell: MatrixParameterValue,
  cellProperties: CellProperties,
) => {
  Handsontable.renderers.TextRenderer.apply(instance, [instance, td, rowIndex, colIndex, prop, cell, cellProperties]);

  td.style.height = "2rem";
  cell.voided ? (td.style.textDecoration = "line-through") : (td.style.textDecoration = "none");
  td.textContent = cell.parameterValue.value;
  applyMatrixInputCellFeedback(td, cellProperties);
};

export default customTextRenderer;
